/* menu.js 导航菜单 */

import merchantRouter from "./merchant.js";

export default [
  // 布局页
  {
    path: "/layout",
    name: "Layout",
    title: "Dashboard",
    component: "layout/index",
    icon: "el-icon-house",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 欢迎页 Welcome
      {
        path: "/layout/welcome",
        name: "Welcome",
        title: "控制台",
        component: "welcome/index",
        icon: "el-icon-monitor",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
    ],
    role: [],
    parentId: 0,
    // 1 目录 2 菜单 3 按钮
    type: 1,
    auth: "",
  },

  /*  */

  ...merchantRouter,
];
